import { render, staticRenderFns } from "./ModifyMarket.vue?vue&type=template&id=ae65ae0a&scoped=true&"
import script from "./ModifyMarket.vue?vue&type=script&lang=ts&"
export * from "./ModifyMarket.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyMarket.vue?vue&type=style&index=0&id=ae65ae0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae65ae0a",
  null
  
)

export default component.exports